import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import BackgroundImage from 'gatsby-background-image'
import { convertToBgImage } from 'gbimage-bridge'

/**
 * isSvgOrGif(): pass image url with file extension
 * as an argument then returns true if file extension
 * includes gif or svg
 * */
import { isSvgOrGif } from '../../utils'

import { outerGbiContainer } from './index.module.css'

const GbiBridged = ({
  file,
  source,
  height,
  width,
  children,
  backgroundStyles,
  objectFit,
  alt,
  ...rest
}) => {
  if (source === null || source === undefined) {
    return <>{children}</>
  }
  const image = getImage(source)
  const bgImage = convertToBgImage(image)
  return isSvgOrGif(file) ? (
    <div
      className={['background-gatsby-image-wrapper', outerGbiContainer].join(
        ' '
      )}
    >
      <div
        {...rest}
        style={{
          backgroundImage: `url('${file}')`,
          ...backgroundStyles,
        }}
      >
        {children}
      </div>
    </div>
  ) : (
    <BackgroundImage
      {...rest}
      Tag="section"
      {...bgImage}
      preserveStackingContext
    >
      <div
        style={{
          top: 0,
          position: 'absolute',
          height: height,
          minHeight: height,
          minWidth: width,
          ...backgroundStyles,
        }}
      >
        <GatsbyImage
          image={image}
          alt={alt}
          imgStyle={{
            objectFit: objectFit,
          }}
          style={{
            top: 0,
            position: 'absolute',
            height: height,
            minHeight: height,
            minWidth: width,
            ...backgroundStyles,
          }}
        />
      </div>
      {children}
    </BackgroundImage>
  )
}
export default GbiBridged
